import React from "react";
import styles from "./Badge.module.css";

/**
 * Badge / label component.
 *
 * Variants:
 *   - "verified"  — blue checkmark (Twitter-style verified)
 *   - "admin"     — small "Admin" label
 *   - "moderator" — small "Mod" label
 *   - "count"     — red notification count bubble
 */
export default function Badge({ variant = "verified", count, label, className = "" }) {
  if (variant === "verified") {
    return (
      <span className={`${styles.verified} ${className}`.trim()} title="Verified">
        {/* Blue check SVG */}
        <svg
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill="var(--color-verified)"
          aria-label="Verified"
        >
          <path d="M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81C14.67 2.63 13.43 1.75 12 1.75s-2.67.88-3.34 2.19c-1.39-.46-2.9-.2-3.91.81s-1.27 2.52-.81 3.91C2.63 9.33 1.75 10.57 1.75 12s.88 2.67 2.19 3.34c-.46 1.39-.2 2.9.81 3.91s2.52 1.27 3.91.81c.67 1.31 1.91 2.19 3.34 2.19s2.67-.88 3.34-2.19c1.39.46 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.67 2.19-1.91 2.19-3.34zm-11.07 4.49l-3.56-3.56 1.41-1.41 2.15 2.15 4.63-4.63 1.41 1.41-6.04 6.04z" />
        </svg>
      </span>
    );
  }

  if (variant === "count") {
    const displayCount = count != null ? count : 0;
    if (displayCount <= 0) return null;
    return (
      <span className={`${styles.count} ${className}`.trim()}>
        {displayCount > 99 ? "99+" : displayCount}
      </span>
    );
  }

  // Role badges (admin, moderator, etc.)
  const text = label || variant;
  return (
    <span
      className={`${styles.role} ${
        variant === "admin" ? styles.admin : styles.moderator
      } ${className}`.trim()}
    >
      {text}
    </span>
  );
}
